import {relayEnvironmentWithMissingFieldHandlerForNode} from '@github-ui/relay-environment'
import {IS_BROWSER} from '@github-ui/ssr-utils'

type IssuesRelayEnvironment = ReturnType<typeof relayEnvironmentWithMissingFieldHandlerForNode>

let browserEnvironment: IssuesRelayEnvironment | undefined

/**
 * The Relay environment backing every Relay-based issue surface -- the dashboard side panel and,
 * via `IssuesLayout`, the repo issues routes -- created once per page load.
 *
 * Never shared on the server: in the long-lived Alloy process a single environment would
 * accumulate every request's data and never be collected, which is what the
 * `no-module-scoped-relay-environment` rule exists to prevent.
 */
export function getIssuesRelayEnvironment(): IssuesRelayEnvironment {
  if (!IS_BROWSER) return relayEnvironmentWithMissingFieldHandlerForNode()

  browserEnvironment ??= relayEnvironmentWithMissingFieldHandlerForNode()
  return browserEnvironment
}
